import { wordCollection } from "../assets/words/words";

export const fromCollection = () => {
  return getWordList(wordCollection);
};

export const getWordList = (wordMap: object): string[] => {
  const genWords = [];

  for (const words of Object.entries(wordMap)) {
    genWords.push(words[1].at(Math.floor(Math.random() * words[1].length)));
  }

  return genWords;
};
